import groupService from '@/services/group.service'
import { createGenericStore } from './generic.store'

export const useGroupStore = createGenericStore<Tag>('groups', groupService)
